import { useEffect, useId, useRef } from "react";
import type { ReactNode } from "react";
import { useLocation } from "react-router";

/**
 * The frame of every auth page: a heading and a section. After the visitor moved here from another
 * page of the app, keyboard and screen reader land on the heading.
 */
export function AuthCard({
  title,
  lead,
  children,
  status,
}: {
  title: string;
  lead?: string | undefined;
  children: ReactNode;
  /** The card is an announcement (check-your-mail, done): read out when it appears. */
  status?: boolean;
}) {
  const id = useId();
  const heading = useRef<HTMLHeadingElement>(null);
  const location = useLocation();
  useEffect(() => {
    if (location.key !== "default") heading.current?.focus();
    // once per page shown
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="adm-login">
      <section className="adm-section" aria-labelledby={id} {...(status ? { role: "status" } : {})}>
        <h1 id={id} ref={heading} tabIndex={-1} className="ds-text-title-1 m-0 login-heading">
          {title}
        </h1>
        {lead ? <p className="ds-text-subheadline text-label-secondary m-0">{lead}</p> : null}
        {children}
      </section>
    </div>
  );
}
